import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'row',
      padding: theme.spacing(4),
      width: theme.spacing(100),
    },
  }),
);

export default useStyles;
